/**
 * ChildAdvisoryFooter — «Sjekk med en voksen»-linjen under barnets svar om
 * mat (Plan 05-08a).
 *
 * Vises under assistentboblen når serveren merker svaret food_adjacent OG
 * medlemmet er barn (AI-10).
 *
 * #158 (steg 8a, Stell_Assistent): en amber linje med varseltrekant rett under
 * boblen, ikke lenger en grønn flate inne i den. Teksten er `text-ai-advisory-fg`
 * (= warn) i 14/700 — litt større enn skissens 12 px, siden det er en
 * sikkerhetslinje for barn. warn på lerretet og i gløden er ≥ 4.5:1 i begge
 * temaer (contrast.test.ts).
 *
 * data-testid: assistant-advisory-footer
 */
import { useTranslation } from 'react-i18next';
import { Icon } from '../../components/primitives';

export function ChildAdvisoryFooter() {
  const { t } = useTranslation();

  return (
    <p
      data-testid="assistant-advisory-footer"
      className="m-0 flex items-center gap-1.5 text-sm font-bold text-ai-advisory-fg"
    >
      <Icon.Warn size={16} className="shrink-0" />
      <span>{t('assistant.advisory.child_food')}</span>
    </p>
  );
}
